import { Injectable, OnDestroy } from '@angular/core';

import { AnalyticsEvent } from '@shared/models';
import { AnalyticsService } from '@shared/services';

@Injectable()
export class EditSessionTrackerService implements OnDestroy {
  private startTime: number | null = null;
  private moduleName!: string;

  constructor(private analytics: AnalyticsService) {}

  start(moduleName: string): void {
    this.moduleName = moduleName;
    this.startTime = Date.now();

    this.analytics.logEvent(AnalyticsEvent.EditSessionStarted, {
      module: this.moduleName,
    });
  }

  finish(outcome: 'saved' | 'cancelled'): void {
    this.track(outcome);
  }

  ngOnDestroy(): void {
    if (this.startTime !== null) {
      this.track('drop_off');
    }
  }

  private track(outcome: string): void {
    if (!this.startTime) return;

    const durationSeconds = Math.round((Date.now() - this.startTime) / 1000);

    this.analytics.logEvent(AnalyticsEvent.EditSessionEnded, {
      module: this.moduleName,
      outcome: outcome,
      duration_seconds: durationSeconds,
    });

    this.startTime = null;
  }
}
